import { z } from "zod"

import { CompanySortField, CompanyStatus, SortingOrder } from "@/graphql/codegen/graphql"

// Schema that matches the route's supplierReportSearchSchema
export const SupplierReportFilterSchema = z.object({
  category: z.string().optional(),
  query: z.string().optional(),
  field: z.nativeEnum(CompanySortField).optional(),
  order: z.nativeEnum(SortingOrder).optional(),
  types: z.array(z.string()).optional(),
  statuses: z.array(z.nativeEnum(CompanyStatus)).optional(),
  managers: z.array(z.string()).optional(),
})
